module.exports = __webpack_public_path__ + "static/media/iconeInstagram.abf628fc.svg";